import React, { useState } from 'react'
import Button from '@mui/material/Button'
import CloudUploadIcon from '@mui/icons-material/CloudUpload'
import CircularProgress from '@mui/material/CircularProgress'
import { upload } from '../api'

const VisuallyHiddenInput = (props) => (
  <input
    style={{
      clip: 'rect(0 0 0 0)',
      clipPath: 'inset(50%)',
      height: 1,
      overflow: 'hidden',
      position: 'absolute',
      bottom: 0,
      left: 0,
      whiteSpace: 'nowrap',
      width: 1,
    }}
    {...props}
  />
)

export default function FileUploader({
  onUploadComplete,
  title = 'Enviar Arquivo',
  path,
  snpPublico = 'N',
  disabled = false,
  inputRef,
}) {
  const [isUploading, setIsUploading] = useState(false)

  const enviarArquivos = async (files) => {
    try {
      setIsUploading(true)

      const response = await upload(files, path, snpPublico)

      if (!response.status) {
        throw new Error(response.dsErro)
      }

      const data = await response

      if (onUploadComplete) {
        onUploadComplete(data)
      }
    } catch (err) {
      const erro = { dsErro: err.message }

      if (onUploadComplete) {
        onUploadComplete(erro)
      }
    } finally {
      setIsUploading(false)
    }
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <Button
        component="label"
        variant="contained"
        startIcon={
          isUploading ? <CircularProgress size={24} /> : <CloudUploadIcon />
        }
        disabled={isUploading || disabled}
      >
        {isUploading ? 'Enviando...' : title}

        <VisuallyHiddenInput
          ref={inputRef}
          type="file"
          multiple
          onChange={(event) => enviarArquivos(event.target.files)}
        />
      </Button>
    </div>
  )
}
